export default __webpack_public_path__ + "0a79147846771524e446b592d308cb8f.png";